import { render, staticRenderFns } from "./HeaderNewBubble.vue?vue&type=template&id=93869a42&scoped=true"
import script from "./HeaderNewBubble.vue?vue&type=script&lang=ts"
export * from "./HeaderNewBubble.vue?vue&type=script&lang=ts"
import style0 from "./HeaderNewBubble.vue?vue&type=style&index=0&id=93869a42&prod&lang=scss&scoped=true"
import style1 from "./HeaderNewBubble.vue?vue&type=style&index=1&id=93869a42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93869a42",
  null
  
)

export default component.exports